export const personalDataInput = 'personal-data-input';
export const profilingDataInput = 'profiling-data-input';
export const personalDataMailCheckInput = 'communication-email';
export const personalDataSmsCheckInput = 'communication-sms';
export const personalDataPhoneCallCheckInput = 'communication-phone-call';
export const toastFeedbackMessage = 'toast-feedback-message';

export const mapPayloadKeyToFieldName = {};

export const profilingDataType = 1;
export const marketingEmailDataType = 2;
export const marketingSmsDataType = 3;
export const marketingPhoneCallDataType = 4;

export const infoPrivacyModalName = 'infoPrivacyModal';
export const personalDataConfirmModalName = 'personalDataConfirmModal';

export const personalDataTreatmentConsentMapping = {
  [personalDataMailCheckInput]: 'personalDataTreatmentConsent_email',
  [personalDataSmsCheckInput]: 'personalDataTreatmentConsent_sms',
  [personalDataPhoneCallCheckInput]: 'personalDataTreatmentConsent_chiamata',
};
